import '@chronos/ui/styles/widget.css';
import _widgetUICss from '@chronos/ui/styles/widget.css?raw';

export const widgetUICss = _widgetUICss;

export * from '@chronos/api';
export * from '@chronos/astro-lib';
export * from '@chronos/ui';
